import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import icon from './icon'
import i18n from './i18n/i18n'

import Vuebar from 'vuebar'
import Vuelidate from 'vuelidate'
import VTooltip from 'v-tooltip'
import VuejsDialog from 'vuejs-dialog'
import './registerServiceWorker'
import VueLoaders from 'vue-loaders';

import 'vuejs-dialog/dist/vuejs-dialog.min.css';

Vue.config.productionTip = false

Vue.use(Vuebar)
Vue.use(Vuelidate)
Vue.use(VTooltip, { disposeTimeout: 0, delay: 1000 })
Vue.use(VuejsDialog, {backdropClose: true})
Vue.use(VueLoaders);

new Vue({
    router,
    store,
    i18n,
    icon,
    render: h => h(App)
}).$mount('#app')
